import React, { memo } from 'react';
import { formatCurrency } from '../helpers';

const ModuloCheques = ({
    chequesBorrador = [],
    chequeInput,
    setChequeInput,
    cuentas = [],
    moneda = 'ARS',
    handleAddChequeBorrador,
    handleRemoveChequeBorrador,
    formatBlurInputAmount
}) => {
    const simboloMoneda = moneda === 'USD' ? 'U$S' : '$';
    const monedaSimbolo = moneda === 'USD' ? 'USD' : 'ARS';

    const totalBorrador = chequesBorrador.reduce((acc, c) => acc + (parseFloat(c.monto) || 0), 0);

    return (
        <div className="p-5 bg-amber-50/20 rounded-xl border border-amber-300/80 space-y-4 animate-fade-in">
            <div className="flex justify-between items-center border-b border-amber-200 pb-2">
                <span className="text-xs font-black text-amber-900 uppercase tracking-wider flex items-center gap-1.5">
                    📜 Cargar Datos del Cheque a Emitir / Entregar
                </span>
                {chequesBorrador.length > 0 && (
                    <span className="text-xs font-mono font-bold text-amber-900 bg-amber-100 px-2.5 py-1 rounded-md">
                        Subtotal Tanda: {formatCurrency(totalBorrador, monedaSimbolo)}
                    </span>
                )}
            </div>

            <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-[14px] font-bold text-amber-900 mb-1.5 pl-1">N° de Cheque *</label>
                        <input
                            type="text"
                            value={chequeInput.numero}
                            onChange={e => setChequeInput(prev => ({ ...prev, numero: e.target.value }))}
                            className="w-full border border-amber-200 rounded-xl px-4 py-2.5 text-sm font-mono font-bold text-slate-800 bg-white h-[46px] outline-none focus:border-amber-400 focus:ring-1 focus:ring-amber-100 transition-all"
                            placeholder="check-01"
                        />
                    </div>

                    <div>
                        <label className="block text-[14px] font-bold text-amber-900 mb-1.5 pl-1">Cuenta / Banco Emisor *</label>
                        <select
                            value={chequeInput.banco}
                            onChange={e => setChequeInput(prev => ({ ...prev, banco: e.target.value }))}
                            className="w-full border border-amber-200 rounded-xl px-4 py-2.5 text-sm font-bold text-slate-800 bg-white h-[46px] outline-none focus:border-amber-400 focus:ring-1 focus:ring-amber-100 transition-all cursor-pointer"
                        >
                            <option value="">Seleccionar Cuenta / Banco...</option>
                            {cuentas.map(c => {
                                const labelLegible = c.nombre || `${c.banco} • ${c.titular || ''} (${c.tipoCuenta || ''})`;
                                return (
                                    <option key={c.id} value={labelLegible}>
                                        {labelLegible}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-[14px] font-bold text-amber-900 mb-1.5 pl-1">Monto ({simboloMoneda}) *</label>
                        <input
                            type="text"
                            value={chequeInput.monto}
                            onChange={e => setChequeInput(prev => ({ ...prev, monto: e.target.value }))}
                            onBlur={() => formatBlurInputAmount(chequeInput.monto, (val) => setChequeInput(prev => ({ ...prev, monto: val })))}
                            className="w-full border border-amber-200 rounded-xl px-4 py-2.5 text-base font-mono font-bold text-slate-800 bg-white h-[46px] outline-none focus:border-amber-400 focus:ring-1 focus:ring-amber-100 transition-all"
                            placeholder="1.500,00"
                        />
                    </div>

                    <div>
                        <label className="block text-[14px] font-bold text-amber-900 mb-1.5 pl-1">F. Vencimiento Pago *</label>
                        <input
                            type="date"
                            value={chequeInput.vencimiento}
                            onChange={e => setChequeInput(prev => ({ ...prev, vencimiento: e.target.value }))}
                            className="w-full border border-amber-200 rounded-xl px-4 py-2.5 text-sm font-bold text-slate-800 bg-white h-[46px] outline-none focus:border-amber-400 focus:ring-1 focus:ring-amber-100 transition-all"
                        />
                    </div>
                </div>

                <div className="pt-1">
                    <button
                        type="button"
                        onClick={handleAddChequeBorrador}
                        className="w-full py-2.5 bg-amber-600 hover:bg-amber-700 text-white rounded-xl font-bold uppercase text-xs transition-all cursor-pointer shadow-xs active:scale-98"
                    >
                        + Cargar Cheque en la Tanda
                    </button>
                </div>

                {chequesBorrador.length > 0 && (
                    <div className="space-y-2 pt-2 border-t border-amber-200">
                        <span className="text-[10px] font-black text-amber-800 uppercase tracking-wider block">
                            Cheques listos para confirmar:
                        </span>
                        {chequesBorrador.map((chk, idx) => (
                            <div key={idx} className="flex items-center justify-between bg-white p-3 rounded-xl border border-amber-200/90 text-xs shadow-xs">
                                <div className="flex items-center gap-2.5 min-w-0 flex-1">
                                    <span className="font-mono font-bold text-slate-900 bg-amber-100/70 px-2 py-0.5 rounded border border-amber-200 text-[11px] shrink-0">
                                        {chk.numero}
                                    </span>
                                    <span className="text-slate-700 font-bold uppercase truncate" title={chk.banco}>
                                        {chk.banco}
                                    </span>
                                </div>

                                <div className="flex items-center gap-3 shrink-0 pl-2">
                                    <span className="font-mono font-black text-amber-950 text-sm">
                                        {formatCurrency(chk.monto, monedaSimbolo)}
                                    </span>

                                    <span className="text-[10px] font-bold text-slate-400 uppercase hidden sm:inline">
                                        Vence: <strong className="text-slate-700 font-mono text-xs">{chk.fechaVencimiento}</strong>
                                    </span>

                                    <button
                                        type="button"
                                        onClick={() => handleRemoveChequeBorrador(idx)}
                                        className="text-rose-500 hover:text-rose-700 font-bold p-1 cursor-pointer transition-colors"
                                    >
                                        ✕
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default memo(ModuloCheques);